import { EditIcon } from "@chakra-ui/icons";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
  Text,
  ModalProps,
  Flex
} from "@chakra-ui/react";
import React from "react";
import Dropdown from "../components/Dropdown";
import { PhuongPhapDinhGiaData } from "../_mocks_";
import { IDropdownItem } from "../_types_";

interface IProps extends Omit<ModalProps, "children"> {

}

export default function LichSuGiaDatDetail({ isOpen, onClose, ...props }: IProps) {
  const [phuongPhaps, setPhuongPhaps] = React.useState<IDropdownItem[]>([]);
  const [phuongPhap, setPhuongPhap] = React.useState<string|number>();

  React.useEffect(() => {
    initData();
  },[isOpen]);
  const initData = () => {
    const lds = PhuongPhapDinhGiaData.map((p) => {
      const item: IDropdownItem = {
        value: p,
        lable: p,
      };
      return item;
    });
    setPhuongPhaps(lds);
   
  }

  const handleChangeLoaiDatValue = (v: string | number) => {
    setPhuongPhap(v);
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" {...props}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Thêm Lịch Sử Giá Đất</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack w="full" alignItems="flex-start">
            
            <Text color="gray.400">Tên đường:</Text>
            <Input
              placeholder="Nhập tên đường chính trong bảng giá đất"
              size="md"
            />
            <Text color="gray.400">Tên hẻm:</Text>
            <Input
              placeholder="Nhập tên hẻm tiếp giáp (nếu có)"
              size="md"
            />
            <Text color="gray.400">Tên đường giao:</Text>
            <Input
              placeholder="Nhập tên đường chính tiếp giáp nếu quy đổi thành hẻm"
              size="md"
            />
            <Text color="gray.400">Phương pháp định giá:</Text>
            <Dropdown
              data={phuongPhaps}
              selectedVal={phuongPhap}
              onChange={(v) =>
                handleChangeLoaiDatValue(v)
              }
            />
            <Text color="gray.400">Thửa liền kề:</Text>
            <Input
              placeholder="Nhập tờ/thửa nếu định giá theo liền kề"
              size="md"
            />
            <Text color="gray.400">Hệ số tiếp giáp:</Text>
            <Input
              placeholder="Nhập hệ số tiếp giáp trường hợp giáp nhiều đường chính"
              _placeholder={{ opacity: 1, color: "gray.500" }}
            />
            <Text color="gray.400">Tổng giá:</Text>
            <Input
              placeholder="Nhập giá tiền theo định giá"
              _placeholder={{ opacity: 1, color: "gray.500" }}
            />
            <Text color="gray.400">Giá thị trường:</Text>
            <Input
              placeholder="Nhập giá thị trường"
              size="md"
              type="number"
            />
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Lưu thông tin
          </Button>
          <Button onClick={onClose}>Bỏ qua</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
